/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useRef, useEffect } from "react";
import get from "lodash.get";
import { getGroupsData, setMaxHeightForRefs } from "../../layout-utils";
import { HeadBlock } from "../../atoms/head-block";
import { Attribute } from "../../attribute";
import { CardImage } from "../../atoms/card-image";
import { SubscribeButton } from "../../atoms/subscribe-button";
import { PriceDetails } from "../../atoms/price-details";
import { Description } from "../../atoms/description";
import { Loader } from "../../atoms/loader";
import "./concrete.m.css";

const SubscriptionBlock = ({
  plans,
  subscriptionConfig = {},
  sso = {},
  member,
  defaultSubscriptionHandler,
  localizedTime,
  mode,
  sketchesHost,
  config
}) => {
  let updateGrid = plans.length < 3 ? { gridTemplateColumns: `repeat(${plans.length}, minmax(auto, 372px))` } : {};
  const { descriptionTitle, showPlanImg = false, showOfferPrice = false } = subscriptionConfig;
  const planRefs = plans.map(() => useRef(null));

  useEffect(() => {
    setMaxHeightForRefs(planRefs);
  }, [plans]);

  return (
    <div styleName="background">
      <div styleName="subscription-wrapper" style={updateGrid}>
        {plans.map((plan, index) => {
          const {
            title,
            description,
            price_currency: priceCurrency,
            price_cents: priceCents,
            image_url: imageUrl,
            id,
          } = plan;
          return (
            <div styleName="plan" key={`plan-${id}`}>
              <div styleName="tag-wrapper">
                <Attribute data={plan} attributeName="Tag" />
              </div>
              <div styleName="title-wrapper">
                <div styleName="title" data-test-id="plan-name" ref={planRefs[index]}>
                  {title}
                </div>
                {showPlanImg && <CardImage title={title} imageUrl={imageUrl} />}
              </div>
              <PriceDetails
                priceCurrency={priceCurrency}
                priceCents={priceCents}
                showOfferPrice={showOfferPrice}
                localizedTime={localizedTime}
                plan={plan}
                mode={mode}
              />
              <SubscribeButton
                sso={sso}
                member={member}
                defaultSubscriptionHandler={defaultSubscriptionHandler}
                subscriptionConfig={subscriptionConfig}
                plan={plan}
                mode={mode}
                sketchesHost={sketchesHost}
                config={config}
              />
              <Description data={description} descriptionTitle={descriptionTitle} mode={mode} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const Concrete = (props) => {
  const groups = getGroupsData(props.currentPath, props.subscriptions);
  const group = groups?.[0] || {};
  const plans = group?.["subscription_plans"] || [];
  const subscriptionConfig = get(props, ["config", "pagebuilder-config", "subscription", "pageSetting"], {});

  if (!plans?.length || props?.isAccessTypeUserSetLoading) {
    return <Loader data={plans} subscriptionConfig={subscriptionConfig} />;
  } else {
    const enableDarkMode = get(props, ["enableDarkMode"], false);
    const mode = enableDarkMode ? "dark" : "light";
    const sso = get(props, ["config", "pagebuilder-config", "general", "sso"], {});
    const sketchesHost = get(props, ["config", "sketches-host"], '');
    return (
      <div styleName={`component-wrapper ${mode}`}>
        <HeadBlock group={group} subscriptionConfig={subscriptionConfig} mode={mode} />
        <SubscriptionBlock
          plans={plans}
          subscriptionConfig={subscriptionConfig}
          sso={sso}
          member={props?.member}
          defaultSubscriptionHandler={props?.defaultSubscriptionHandler}
          localizedTime={props?.localizedTime}
          mode={mode}
          sketchesHost={sketchesHost}
          config={props?.config}
        />
      </div>
    );
  }
};
